module.exports = __webpack_public_path__ + "img/triangle.b8653359.svg";